import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import CaseDetailsPage from './CaseDetailsPage';

const CaseDetailsRouter = () => (
    <Routes >
        <Route path=":caseId/" element={<CaseDetailsPage />} />
        <Route path="submitted/:caseId/" element={<CaseDetailsPage submittedCase />} />

        <Route
            path="*"
            element={<Navigate to="/404" replace />}
        />
    </Routes>
);

CaseDetailsRouter.displayName = 'Router';

export default CaseDetailsRouter;
